var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4507 3.43337L10.8673 1.7167C10.3923 1.5417 9.61732 1.5417 9.14232 1.7167L4.55898 3.43337C3.67565 3.7667 2.95898 4.80003 2.95898 5.7417V12.4917C2.95898 13.1667 3.40065 14.0584 3.94232 14.4584L8.52565 17.8834C9.33398 18.4917 10.659 18.4917 11.4673 17.8834L16.0506 14.4584C16.5923 14.05 17.034 13.1667 17.034 12.4917V5.7417C17.0423 4.80003 16.3257 3.7667 15.4507 3.43337ZM12.9007 8.10003L9.31732 11.6834C9.19232 11.8084 9.03398 11.8667 8.87565 11.8667C8.71732 11.8667 8.55898 11.8084 8.43398 11.6834L7.10065 10.3334C6.85898 10.0917 6.85898 9.6917 7.10065 9.45003C7.34232 9.20837 7.74232 9.20837 7.98398 9.45003L8.88398 10.35L12.0257 7.20837C12.2673 6.9667 12.6673 6.9667 12.909 7.20837C13.1507 7.45003 13.1506 7.85837 12.9007 8.10003Z",
    fill: "#677481"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/Shield.694a6ad45cef80561cf63d7d098b2e61.svg";
export { ForwardRef as ReactComponent };